/**
 * Currency catalogue — byte-for-byte copy of
 * `RW-ERP-Service/src/types/library/currency.ts`. Kept in sync so a
 * `currencyCode` accepted by one app is accepted by the other.
 */
export const CURRENCY_CODES = {
  USD: 'USD',
  INR: 'INR',
  EUR: 'EUR',
  GBP: 'GBP',
  AUD: 'AUD',
  CAD: 'CAD',
  CHF: 'CHF',
  CNY: 'CNY',
  JPY: 'JPY',
  NZD: 'NZD',
  SEK: 'SEK',
  MXN: 'MXN',
  SGD: 'SGD',
  HKD: 'HKD',
  NOK: 'NOK',
  KRW: 'KRW',
  TRY: 'TRY',
  RUB: 'RUB',
  BRL: 'BRL',
  ZAR: 'ZAR',
  DKK: 'DKK',
  PLN: 'PLN',
  THB: 'THB',
  IDR: 'IDR',
  HUF: 'HUF',
  CZK: 'CZK',
  ILS: 'ILS',
  CLP: 'CLP',
  PHP: 'PHP',
  AED: 'AED',
  COP: 'COP',
  SAR: 'SAR',
  MYR: 'MYR',
  RON: 'RON',
} as const;

export type CurrencyCode = keyof typeof CURRENCY_CODES;

export const CURRENCY: ReadonlyArray<string> = Object.keys(CURRENCY_CODES);

/**
 * Abbreviation suffixes — index 0 = thousands ("K"), 1 = millions ("Mn"),
 * 2 = billions ("Bn"), 3 = trillions ("T"), 4 = quadrillions ("P").
 */
export const CURRENCY_SUFFIX: ReadonlyArray<string> = ['K', 'Mn', 'Bn', 'T', 'P'];

export const DEFAULT_CURRENCY_CODE: CurrencyCode = 'USD';
export const DEFAULT_LOCALE = 'en-US';
